import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import LazyLoad from './lazyLoad';

export default class ProductGallery {
    constructor(container) {
        this.thumbnailSliderContainer = container.querySelector('.thumbnail-slider');
        this.fadeSliderContainer = container.querySelector('.fade-slider');

        this.handleSliders();
    }

    handleSliders = async () => {
        await this.initMainSlider();
        await this.initThumbnailSlider();
        await this.syncSliders();
    };

    initMainSlider = () => {
        return new Promise((resolve, reject) => {
            this.fadeSlider = new Splide(this.fadeSliderContainer, {
                type: 'fade',
                rewind: true,
                pagination: false,
                arrows: false,
            });

            resolve();
        });
    };

    initThumbnailSlider = () => {
        return new Promise((resolve, reject) => {
            this.thumbnailSlider = new Splide(this.thumbnailSliderContainer, {
                fixedWidth: 115,
                gap: 20,
                pagination: false,
                isNavigation: true,
                updateOnMove: true,
                arrows: true,

                breakpoints: {
                    1024: { arrows: false, fixedWidth: 102, gap: 20 },
                },
            });

            resolve();
        });
    };

    syncSliders = () => {
        return new Promise((resolve, reject) => {
            this.fadeSlider.sync(this.thumbnailSlider);
            this.fadeSlider.mount();
            this.thumbnailSlider.mount();
            LazyLoad();
            resolve();
        });
    };

    changeSlide = async (id) => {
        const slides = [...this.thumbnailSliderContainer.querySelectorAll(`[data-variation="${id}"]`)];

        slides.forEach((slide) => {
            if (!slide.classList.contains('splide__slide--clone')) {
                const id = parseInt(slide.dataset.key);
                this.thumbnailSlider.go(id);
            }
        });
    };
}
